import styled from 'styled-components';

export const MenuTileGridContainer = styled.div`
  margin: 0;

  padding-block-start: 2rem;
  padding-block-end: 5rem;
  padding-inline: 1rem;

  ${Styles.desktop} {
    margin-block: 1rem;
    margin-inline: auto;

    padding: 0;
    width: ${Styles.layout.sectionMaxWidth};
  }
`;

export const MenuListGridContainer = styled.div`
  margin: 0;

  ${Styles.desktop} {
    margin: 2rem;
    padding: 0;
  }
`;

export const MenuTileGridInner = styled.div`
  display: grid;
  text-decoration: none;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1.5rem;
  min-height: 250px;

  ${Styles.mobileLandscape} {
    grid-template-columns: 1fr 1fr;
  }

  ${Styles.desktop} {
    grid-template-columns: 1fr 1fr 1fr;
    max-width: ${Styles.layout.sectionMaxWidth};

    margin-block: 0;
    margin-inline: auto;
  }
`;

export const MenuListGridInner = styled.div`
  display: grid;
  text-decoration: none;
  grid-template-columns: 1fr;

  ${Styles.desktop} {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1.5rem;
    max-width: ${Styles.layout.sectionMaxWidth};
    margin: 0 auto;
  }
`;
